<template>
  <div class="pc_login">
    <div class="title" @click="aha()">河南大学教学管理服务平台后台管理系统</div>
    <div class="loginBOX">
      <div class="loginTXT">用户登录</div>
      <input type="text" class="name" placeholder="用户名" v-model="name" />
      <input type="password" class="name" placeholder="密码" v-model="pwd" />
      <div class="loginBTN" @click="login()">登 录</div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
export default {
  name: "pc_login",
  data: function () {
    return {
      name: "",
      pwd: "",
    };
  },
  methods: {
    login: function () {
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/user/login" +
          "/" +
          this.name +
          "/" +
          this.pwd,
      }).then((res) => this.iflogin(res.data));
    },
    iflogin: function (resData) {
      console.log(resData);
      if (resData.code == 1) {
        this.$router.push("./manage");
        console.log("登录成功");
        // this.$router.push({
        //   path: "./manage",
        //   name: "Manage",
        //   params: {
        //     iflogin: true,
        //   },
        // });
        // this.$store.commit("ifLogin", true);
        // console.log(this.$store.state.ifLogin);
        let json = {
          iflogin: true,
          Department: resData.Department,
        };
        let jsonStr = JSON.stringify(json);
        document.cookie = jsonStr;
        console.log(document.cookie);
        // console.log(JSON.parse(document.cookie).iflogin);
        // console.log(JSON.parse(document.cookie).Department);
      } else if (resData.code == 0) {
        alert("登陆失败，请重新检查账户密码");
        this.$store.commit("ifLogin", false);
        document.cookie = false;
      }
    },
  },
};
</script>

<style scoped>
.pc_login {
  width: 1200px;
  /* height: 1000px; */
  padding-bottom: 200px;
  background-color: whitesmoke;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -350px;
  margin-left: -600px;
}

.title {
  height: 200px;
  font-size: 50px;
  line-height: 200px;
}

.loginBOX {
  width: 500px;
  margin: auto;
  border-radius: 5px;
  background-color: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 30px;
}

.loginTXT {
  width: 400px;
  height: 50px;
  line-height: 50px;
  text-align: left;
  margin: auto;
  font-size: 23px;
  /* background-color: pink; */
}

.name {
  width: 400px;
  height: 50px;
  /* border: none; */
  border: 1px solid #999999;
  margin-top: 10px;
  outline: none;
  font-size: 15px;
  box-sizing: border-box;
  padding-left: 10px;
  border-radius: 5px;
}

.loginBTN {
  width: 160px;
  height: 40px;
  border-radius: 40px;
  line-height: 40px;
  margin: auto;
  margin-top: 35px;
  background-color: #0099ff;
  color: white;
  font-size: 20px;
}
.loginBTN:hover {
  cursor: pointer;
}
</style>